// extracted by mini-css-extract-plugin
export var callCard = "_ip-0";
export var callMessageButton = "_ip-1";
export var helpIcon = "_ip-3";
export var helpIconContainer = "_ip-4";
export var verticalDivider = "_ip-2";